<div class="ng-select-wrapper" [attr.isError]="isError">
  <div class="select-btn-wrapper" #selectRef
       [enabled]="selectRef.hasAttribute('openMenu')"
       (appOutsideClick)="selectRef.removeAttribute('openMenu');">
    <button class="select-btn"
            id="selectBtn"
            type="button"
            [disabled]="disabled"
            (click)="selectRef.toggleAttribute('openMenu')">
      <div class="select-btn-flag-with-code-wrapper">
        <img [src]="'https://hatscripts.github.io/circle-flags/flags/' + selectedCountry?.code.toLowerCase() + '.svg'" loading="lazy" class="country-flag">
        <span>{{selectedCountry?.dial_code}}</span>
      </div>
      <svg class="select-icon-dropdown">
        <use spriteVersion iconName="arrow-select-area-status"></use>
      </svg>
    </button>


    <div class="select-menu-wrapper">
      <ul class="select-menu">
        @for (country of countriesList; track country) {
<li class="select-menu__item" (click)="changeOption(country); selectRef.removeAttribute('openMenu')">
          <p class="select-menu__text"
             [attr.selectedOption]="country === selectedCountry">
            <img [src]="'https://hatscripts.github.io/circle-flags/flags/' + country.code.toLowerCase() + '.svg'" loading="lazy" class="country-flag">
            {{country.dial_code}}
          </p>
        </li>
}
      </ul>
    </div>
  </div>
</div>
